export default "__VITE_ASSET__Bv6PhGLB__"